import { TagData } from "./tag-row.component";

export const mockTagsData: TagData[] = [
  { id: 1, name: "Referral", associatedMSPs: 5, color: "#5244B3" },
  { id: 2, name: "Hot Lead", associatedMSPs: 23, color: "#DF6844" },
  { id: 3, name: "New Tag", associatedMSPs: 12, color: "#008FD4" },
  {
    id: 4,
    name: "Newer Tag",
    associatedMSPs: 0,
    color: "#008FD4",
  },
  {
    id: 5,
    name: "Disabled Tag",
    associatedMSPs: 12,
    color: "#BBBEC9",
    isDisabled: true,
  },
];

